import coming_soon from './coming_soon.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={coming_soon} className="App-coming-soon" alt="coming soon" />
      </header>
    </div>
  );
}

export default App;
